import { createApp } from 'vue';
import App from './App.vue';
import { createRouter, createWebHistory } from 'vue-router'; // Import createRouter and createWebHistory from 'vue-router'

import Home from './components/HomePage.vue';

import ProssingFour from './components/ProssingFour.vue';



const routes = [
    { path: '/', component: Home },
   
    { path: '/dmll', component: ProssingFour },
   

];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

createApp(App).use(router).mount('#app');
